module.exports = {"430971121":"河坝镇","430971123":"金盆镇","430971124":"北洲子镇","430971130":"千山红镇","430971405":"南湾湖"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430971.json
// module id = 1889
// module chunks = 0